<template>
  <div class="row help-wrapper">
    <!-- <header-about /> -->
    <div id="corpo" class="col s12">
      <h5 class="center" id="manual">CNIS - MEU INSS</h5>
      <p>
        Para fazer o download do seu CNIS - Cadastro Nacial de Informações Sociais siga o passo-a-passo a seguir, leva menos de 5 minutos e você pode fazer
        agora mesmo, sem precisar sair de casa.
      </p>
      <p>
        1 - Acesse o site do <a target="_blank" href="https://meu.inss.gov.br/">Meu INSS</a>. <br />
        2 - Acesse com os seus dados, caso ainda não tenha acesso, você consegue fazer o seu cadastro e conseguí-lo em menos de 5 minutos. <br />
        3 - Na página inicial do <a target="_blank" href="https://meu.inss.gov.br/">Meu INSS</a>, selecione a opção "<strong>Extrato de Contribuição(CNIS)</strong>", conforme a imagem abaixo:
      </p>
      <p class="col s12">
        <img class="col s12 m3 materialboxed" src="@/assets/img/meu_inss_cnis.png" alt="cadastro_em_analise" />
      </p>
      <p>
        4 - Na página seguinte você verá uma lista com o histórico das suas contribuições previdenciárias agrupadas por empregador. <br />
        5 - Para fazer o donwload, clique na opção "BAIXAR PDF" no canto inferior direito da página. <br />
        6 - O arquivo será salvo no seu smpartphone, tablet ou computador em formato "PDF", que você poderá utilizar para completar o seu cadastro na Recad Censo®.
      </p>
      <div class="col s12 center">
        <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin center s12" id="abouBtnLogin">
          Voltar
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderAbout from "@/components/HeaderAbout.vue"

export default {
  name: 'Ajuda',
  components: {
    "header-about": HeaderAbout
  },
  data (){
    return {
      active_step: 1,
      last_page: this.$store.state.route.from.fullPath,
    }
  },
  methods: {
    initMaterialize() {
      setTimeout(() => {
        M.Collapsible.init((document.querySelectorAll('.collapsible')))
        M.Materialbox.init(document.querySelectorAll('.materialboxed'))
      }, 100)
    }
  },
  mounted(){
    this.$root.$emit('stopLoadingHeader')
    this.initMaterialize()
    
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TutorialCnis.vue